import { useState, useEffect, useRef } from "react";
import { GoogleMapsProvider, useGoogleMap } from "@ubilabs/google-maps-react-hooks";
import { MAP_KEY, mapOptions } from "../../constants/cons";

const Marcador = ({ lat, lon }) => {
  const map = useGoogleMap();
  const markerRef = useRef();

  useEffect(() => {
    if (!map) return;

    const position = { lat: parseFloat(lat), lng: parseFloat(lon) };

    if (!markerRef.current) {
      markerRef.current = new window.google.maps.Marker({ map, position });
    } else {
      markerRef.current.setPosition(position);
    }

    map.panTo(position);
    map.setZoom(15);

    return () => {
      if (markerRef.current) markerRef.current.setMap(null);
    };
  }, [map, lat, lon]);

  return null;
};

export const MapaPasarLatLng = ({ lat, lon, height = 300 }) => {
  const [mapContainer, setMapContainer] = useState();

  return (
    <GoogleMapsProvider
      libraries={['places']}
      googleMapsAPIKey={MAP_KEY}
      mapOptions={mapOptions}
      mapContainer={mapContainer}
    >
      <div
        style={{ height: `${height}px`, width: '100%', marginTop: 10 }}
        ref={(node) => setMapContainer(node)}
      />
      <Marcador lat={lat} lon={lon} />
    </GoogleMapsProvider>
  );
};
